/* tslint:disable */
/* eslint-disable */
/**
 * Stututu API
 * REST API for the Stututu car community.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ListEvents200ResponseLinks } from './ListEvents200ResponseLinks';
import {
    ListEvents200ResponseLinksFromJSON,
    ListEvents200ResponseLinksFromJSONTyped,
    ListEvents200ResponseLinksToJSON,
    ListEvents200ResponseLinksToJSONTyped,
} from './ListEvents200ResponseLinks';
import type { ListEvents200ResponseMeta } from './ListEvents200ResponseMeta';
import {
    ListEvents200ResponseMetaFromJSON,
    ListEvents200ResponseMetaFromJSONTyped,
    ListEvents200ResponseMetaToJSON,
    ListEvents200ResponseMetaToJSONTyped,
} from './ListEvents200ResponseMeta';
import type { ListEvents200ResponseDataInner } from './ListEvents200ResponseDataInner';
import {
    ListEvents200ResponseDataInnerFromJSON,
    ListEvents200ResponseDataInnerFromJSONTyped,
    ListEvents200ResponseDataInnerToJSON,
    ListEvents200ResponseDataInnerToJSONTyped,
} from './ListEvents200ResponseDataInner';

/**
 * 
 * @export
 * @interface ListEvents200Response
 */
export interface ListEvents200Response {
    /**
     * 
     * @type {Array<ListEvents200ResponseDataInner>}
     * @memberof ListEvents200Response
     */
    data?: Array<ListEvents200ResponseDataInner>;
    /**
     * 
     * @type {ListEvents200ResponseLinks}
     * @memberof ListEvents200Response
     */
    links?: ListEvents200ResponseLinks;
    /**
     * 
     * @type {ListEvents200ResponseMeta}
     * @memberof ListEvents200Response
     */
    meta?: ListEvents200ResponseMeta;
}

/**
 * Check if a given object implements the ListEvents200Response interface.
 */
export function instanceOfListEvents200Response(value: object): value is ListEvents200Response {
    return true;
}

export function ListEvents200ResponseFromJSON(json: any): ListEvents200Response {
    return ListEvents200ResponseFromJSONTyped(json, false);
}

export function ListEvents200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListEvents200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(ListEvents200ResponseDataInnerFromJSON)),
        'links': json['links'] == null ? undefined : ListEvents200ResponseLinksFromJSON(json['links']),
        'meta': json['meta'] == null ? undefined : ListEvents200ResponseMetaFromJSON(json['meta']),
    };
}

export function ListEvents200ResponseToJSON(json: any): ListEvents200Response {
    return ListEvents200ResponseToJSONTyped(json, false);
}

export function ListEvents200ResponseToJSONTyped(value?: ListEvents200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(ListEvents200ResponseDataInnerToJSON)),
        'links': ListEvents200ResponseLinksToJSON(value['links']),
        'meta': ListEvents200ResponseMetaToJSON(value['meta']),
    };
}

